// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__EmDD9","list":"BalanceDue_list__1zgz_","listRow":"BalanceDue_listRow__3DBMh","total":"BalanceDue_total__2olSg"};